import UUIDBase from '../UUIDBase'
import ItemSerial from './ItemSerial'

export class ItemStockExtraProperties {
  batchNumber?: string
  expiryDate?: Date
  manufactureDate?: Date
}

export default class Stock extends UUIDBase {
  location = {}
  quantity = 0
  pendingQuantity = 0


  itemSerials = new Array<ItemSerial>()
  extraProperties: ItemStockExtraProperties = new ItemStockExtraProperties()
}
